# ---
# Возвращает LatLngBounds расширенный с нужным фактором
# ---
expandBounds = (bounds, factor=1.0) ->
  center = bounds.getCenter()

  ne = bounds.getNorthEast()
  sw = bounds.getSouthWest()

  return unless window.google

  neExt = new google.maps.LatLng(
    center.lat() + (ne.lat() - center.lat()) * factor,
    center.lng() + (ne.lng() - center.lng()) * factor
  )

  swExt = new google.maps.LatLng(
    center.lat() + (sw.lat() - center.lat()) * factor,
    center.lng() + (sw.lng() - center.lng()) * factor
  )

  new google.maps.LatLngBounds(swExt, neExt)


###
# Отображение заказов в маркеры
###
computedMarkers = (dependentKey) ->

  options =
    # При добавлении заказа
    addedItem: (array, order, changeMeta, instanceMeta) ->
      if order.get('takeaway')
        lat = order.get('restaurant.latitude')
        lon = order.get('restaurant.longitude')
      else
        lat = order.get('latitude')
        lon = order.get('longitude')

      marker = null

      if lat and lon and window.google
        coordinates = new google.maps.LatLng(lat, lon)

        icon = new google.maps.MarkerImage(
          order.get('marker'),
            new google.maps.Size(26, 26),
            new google.maps.Point(0, 0),
            new google.maps.Point(8, 8),
            new google.maps.Size(16, 16))

        marker = new google.maps.Marker
          position: coordinates
          map: @get('map')
          icon: icon

        if @get('animateNewMarkers')
          marker.setAnimation(google.maps.Animation.DROP)

        marker.setMap @get('map')
        @registerMarker(marker)

        google.maps.event.addListener marker, 'click', =>
          @sendAction('onOrderSelected', order)

      array.insertAt changeMeta.index, { marker: marker, model: order }
      array

    # При удалении заказа
    removedItem: (array, item, changeMeta, instanceMeta) ->
      arrayItem = array.findBy('model', item)
      return unless arrayItem

      marker = arrayItem.marker
      marker.setMap(null)

      array.removeAt(changeMeta.index, 1)
      array

  Em.arrayComputed(dependentKey, options)


###
# Маркеры для курьеров
###
renderCouriers = ->

  showCourierPopup = (courier, currentOrder, marker) =>

    courier.getStatus()
    .then =>

      infowindow = new google.maps.InfoWindow(content: getInfoWindowContent(courier, currentOrder))
      infowindow.open(@get('map'), marker)
      @infowindows.push infowindow

      if currentOrder
        currentOrder.get('restaurant')
        .then (restaurant) =>
          restaurantMarker = @get('restaurantsMarkers').get(restaurant.get('id'))
          address_marker = @get('markers').findBy('model', currentOrder)?.marker

          from_point = marker.getPosition()
          if courier.get('status') == 'delivering'
            to_point = address_marker?.getPosition()
          else
            to_point = restaurantMarker.getPosition()

          @drawLine(from_point, to_point)

  findOrCreateMarker = (courier) =>
    if !@get('courierMarkerCache')
      @set('courierMarkerCache', Em.A([]))

    match = @get('courierMarkerCache').filter (m) =>
      m.id is courier.get('id')

    if match and match.length >= 1
      return match[0]

    return unless window.google

    icon = new google.maps.MarkerImage(
      courier.get('avatarUrl'),

      new google.maps.Size(40, 40),
      new google.maps.Point(0, 0),
      new google.maps.Point(20, 20),
      new google.maps.Size(40, 40))

    marker = new google.maps.Marker
      icon: icon


    id = courier.get('id')
    markerObj = Em.Object.create({ id, marker })
    @get('courierMarkerCache').pushObject(markerObj)

    marker.setTitle( courier.get('name') )
    marker.addListener 'click', () =>
      @infowindows = [] unless @infowindows
      while iw = @infowindows.shift()
        iw.close()


      courier.get('currentOrder')
      .then (currentOrder) =>
        showCourierPopup(courier, currentOrder, marker)

    markerObj

  formatDate = (date, tz) =>
    d = moment(new Date date)
    d = d.tz(tz) if tz
    if d.isSame(moment(), 'day')
      d.format('H:mm')
    else
      d.format('DD MMMM в H:mm')



  getInfoWindowContent = (courier, currentOrder) =>

    params = {}

    if currentOrder
      params = {
        restaurant: currentOrder.get('restaurant.name'),
        address: currentOrder.get('address_text')
      }

    ret = "<div class='courier-info-window'>
        <h4>#{courier.get('name')}</h4>
        <p>#{Em.I18n.t 'orders_map.courier_popup.statuses.' + courier.get('status'), params}</p>"

    if currentOrder
      ret += "<a class='order-number' href='#/orders/map/#{currentOrder.get('id')}?f=current'>
        #{Em.I18n.t 'order.map_popup.order_name', order: currentOrder.get('number')}
      </a>"


    orders = courier.get('statusData').orders

    if orders.length > 0
      ret += '<h5>Очередь заказов</h5>'
      ret += '<ul>'
      # ret += '<tr><th>cтатус</th><th>забрать</th><th>доставить</th><th>Заказ и адрес</th></tr>'
      orders.forEach (order) =>

        pickup = formatDate(order.picked_up_at || order.pick_up_at, currentOrder.get('timezone'))
        delivery_at = formatDate(order.delivery_at, currentOrder.get('timezone'))

        ret += "<li>
          <div>
            #{Em.I18n.t 'order.status.'+order.status}<br>
            <a class='order-number' href='#/orders/map/#{order.id}?f=current'>
              №#{order.number}
            </a>
          </div>
          <div>#{pickup}<br>#{order.restaurant_name}</div>
          <div>&rarr;</div>
          <div>#{delivery_at}<br>#{order.address}</div>
        </li>"

      ret += '</ul>'

    ret += "</div>"

  i = 0
  @get('courierPositions').forEach (c) =>
    m = findOrCreateMarker( c )
    marker = m.get('marker')

    marker.setMap( @get('map') )
    @registerMarker(marker)

    pos    = new google.maps.LatLng(c.get('lat'), c.get('lng'))
    oldPos = marker.getPosition()

    if not oldPos?.equals( pos )
      marker.setPosition( pos )

    marker.setZIndex(1000 + i)
    i += 1

    opacity = switch
      when c.get('lostConnection')
        0.2
      when c.get('longAgoConnection')
        0.7
      else
        1.0

    marker.setOpacity( opacity )





###
# Компонент карты
###
App.OrdersMapGoogleComponent = Em.Component.extend
  classNames: ['orders-map', 'orders-map-google']

  map:           null
  orders:        null
  restaurants:   null
  selectedOrder: null
  markers:        computedMarkers('orders', 'map')
  session:  Em.inject.service()

  animateNewMarkers: false

  redrawCouriers: renderCouriers.observes('courierPositions')
  courierMarkerCache: null

  ###
  # Инициализация карты
  ###
  registerMap: (->
    return unless @$()?.get(0)

    # очень кривое решение ожидания загрузки гугла, но должно работать
    unless window.google
      setTimeout =>
        @registerMap()
      , 1000

      return

    mapOptions = {
      zoom: 3
      center: new google.maps.LatLng(56.0031895, 71.5048241)
      mapTypeId: google.maps.MapTypeId.ROADMAP
      scrollwheel: localStorage.getItem('mapScrollOnMouseWheel') == 'true'
      disableDefaultUI: true
      zoomControl: true
    }

    if window.googleMapCacheInspance
      old_id = @$().attr('id')
      prev_map = $('body #googleMapCacheContainer > div').attr('id',old_id)
      @$().replaceWith prev_map
      map = window.googleMapCacheInspance
    else
      @get('session.currentUser').stat('googleMap','orders-map')
      map = new google.maps.Map(@$().get(0), mapOptions)

    google.maps.event.clearListeners map, 'click'
    google.maps.event.addListener map, 'click', => @sendAction('onOrderSelected', null)

    @set('map', map)

    @set('initialized', true)
    @get('obtainDefers').forEach (defer) =>
      defer.resolve(map)

    @addRestaurantsMarkers()
    @fitBounds()

    # directionsDisplay = new google.maps.DirectionsRenderer()
    # directionsDisplay.setOptions
      # suppressMarkers: true   # Не показывать A, B маркеры
      # preserveViewport: true  # Не зумить при смене маршрута

    # directionsDisplay.setMap(map)

    # @set('directionsDisplay', directionsDisplay)
    # @set('directionsService', new google.maps.DirectionsService())
    @set('animateNewMarkers', true)

  ).on('didInsertElement')

  cacheOldMap: (->
    if window.cachedMarkers
      window.cachedMarkers.forEach (marker) ->
        marker.setMap(null) if marker && marker.setMap

    window.cachedMarkers = []

    return unless @get('map')

    unless window.googleMapCacheInspance
      window.googleMapCacheContainer = $(@get('map').getDiv())[0]
      window.googleMapCacheInspance = @get('map')

    $('body #googleMapCacheContainer').append window.googleMapCacheContainer;

  ).on('willDestroyElement')

  # глобальная структура для регистрации всех маркеров, добавленных на карту
  # чтобы удалять их перед записью карты в кеш при выходе
  registerMarker: (marker) ->
    window.cachedMarkers = [] unless window.cachedMarkers
    window.cachedMarkers.push marker

  registerLine: (line) ->
    window.cachedLines = [] unless window.cachedLines
    window.cachedLines.push line

  clearLines: () ->
    return false unless window.cachedLines
    window.cachedLines.forEach (line) ->
      line.setMap(null) if line && line.setMap


  ###
  # Центрирование карты
  ###
  fitBounds: ->
    map = @get('map')
    bounds = new google.maps.LatLngBounds()

    has_points = false
    @get('markers').filter (marker) => marker.marker
    .map (marker) =>
      position = marker.marker.getPosition()
      coordinates = new google.maps.LatLng(position.lat(), position.lng())
      bounds.extend(coordinates)
      has_points = true

    @get('restaurants').forEach (restaurant) =>
      if restaurant.get('hasCoordinates')
        coordinates = new google.maps.LatLng(restaurant.get('latitude'), restaurant.get('longitude'))
        bounds.extend(coordinates)
        has_points = true

    # @get('couriers').forEach (c) =>
    #   if c.get('lat') and c.get('lng')
    #     pos    = new google.maps.LatLng(c.get('lat'), c.get('lng'))
    #     bounds.extend(pos)
    #     has_points = true

    map.fitBounds(bounds) if has_points

  initialized: false

  initializeProps: (->
    @set('obtainDefers', Em.A([]))
  ).on('init')

  # ---
  # Запрашивает экземпляр карты. Гарантирует, что карта инициализирована
  # ---
  obtainMap: ->
    defer = Em.RSVP.defer()

    if @get('initialized')
      defer.resolve(@get('map'))
    else
      @get('obtainDefers').pushObject(defer)

    defer.promise

  drawLine: (from, to) ->
    @clearLines()

    return unless from and to

    if from && from.equals(to)
      @get('map').setZoom(17)
      @get('map').panTo( from )
      # @get('directionsDisplay').setMap(null)
      return

    bounds = new google.maps.LatLngBounds()
    bounds.extend(from)
    bounds.extend(to)
    @get('map').fitBounds(expandBounds(bounds, 2.5))

    lineSymbol = {
      path: 'M 0,-1 0,1',
      strokeOpacity: .8,
      scale: 4,
      strokeColor: '#35ade8',
    };

    polyline = new google.maps.Polyline(
      path: [from,to],
      geodesic: true,
      strokeOpacity: 0,
      strokeWeight: 5,
      icons: [{
        icon: lineSymbol,
        offset: '0',
        repeat: '20px'
      }],
    )
    polyline.setMap(@get('map'))
    @registerLine(polyline)

  ###
  # Центрирование по маркеру
  ###
  onSelectedOrderChanged: (->
    @obtainMap()
    .then (map) =>
      @get('markers')
      .filter (m) => m.marker
      .forEach (marker) ->
        marker.marker.setAnimation(null)

      return unless @get('selectedOrder')?

      order = @get('selectedOrder')

      order.reload()
      .then =>
        order.get('restaurant')
        .then (restaurant) =>
          return unless restaurant

          restaurantMarker = @get('restaurantsMarkers').get(restaurant.get('id'))
          marker = @get('markers').findBy('model', order)?.marker

          return unless marker

          unless restaurantMarker
            @get('map').setZoom(17)
            @get('map').panTo( marker.getPosition() )
            return

          orderPosition      = marker.getPosition()
          restaurantPosition = restaurantMarker.getPosition()

          @drawLine(orderPosition, restaurantPosition)

        # request =
        #   origin:      restaurantPosition
        #   destination: orderPosition
        #   travelMode:  google.maps.TravelMode.DRIVING

        # @get('directionsService').route request, (response, status) =>
        #   if (status == google.maps.DirectionsStatus.OK)
        #     @get('directionsDisplay').setMap(@get('map'))
        #     @get('directionsDisplay').setDirections(response)
        #     @get('map').fitBounds(expandBounds(response.routes[0].bounds, 2.5))


      # @get('map').fitBounds(extendedBounds(points, 1.5), 3000)
  ).observes('selectedOrder').on('didInsertElement')

  onOrderStatusChanged: (->
    @obtainMap()
    orders = @get('orders')
    orders.forEach (order) =>
      marker = @get('markers').findBy('model', order)?.marker
      cachedLine = if window.cachedLines then window.cachedLines.find (line) => line.userData == order.get('id') else null
      if marker
        if order.get('status') == 'complete'
          marker.setMap(null)
          cachedLine?.setMap(null)
        else
          marker.setMap(null)

          lat = null
          lon = null

          if order.get('takeaway')
            lat = order.get('restaurant.latitude')
            lon = order.get('restaurant.longitude')
          else
            lat = order.get('latitude')
            lon = order.get('longitude')

          coordinates = new google.maps.LatLng(lat, lon)

          icon = new google.maps.MarkerImage(
            order.get('marker'),
            new google.maps.Size(26, 26),
            new google.maps.Point(0, 0),
            new google.maps.Point(8, 8),
            new google.maps.Size(16, 16))

          marker = new google.maps.Marker
            position: coordinates
            map: @get('map')
            icon: icon

  ).observes('orders.@each.status')

  ###
  # Добавить рестораны на карту
  ###
  addRestaurantsMarkers: ->
    geocoder  = new google.maps.Geocoder()
    map       = @get('map')
    icon = new google.maps.MarkerImage(
      "images/map-markers/restaurant-marker-round.png",
      new google.maps.Size(52, 52),
      new google.maps.Point(0, 0),
      new google.maps.Point(14, 14),
      new google.maps.Size(28, 28))

    @set('restaurantsMarkers', Ember.Object.create())

    @get('restaurants')
    .filter (r) => r.get('hasCoordinates')
    .forEach (restaurant) =>
      lat = restaurant.get('latitude')
      lon = restaurant.get('longitude')

      coordinates = new google.maps.LatLng(lat, lon)

      marker = new google.maps.Marker
        map:      map
        position: coordinates
        icon:     icon
        title:    restaurant.get('name')

      @get('restaurantsMarkers').set(restaurant.get('id'), marker)
